import axiosInstance from "../api/axiosInstance";

/** Same admin routes as match control (`/admin/interactions`) */
export const fetchCompatibilities = (params) =>
  axiosInstance.get("/admin/interactions", { params });

export const fetchCompatibilityById = (id) =>
  axiosInstance.get(`/admin/interactions/${id}`);

export const updateCompatibility = (payload) =>
  axiosInstance.post("/admin/match-override", payload);

export const deleteCompatibility = (id) =>
  axiosInstance.delete(`/admin/interactions/${id}`);

export const deleteCompatibilityBulk = (payload) =>
  axiosInstance.post("/admin/interactions/deleteBulk", payload);

// Introductions page actions (2026-09-01): run one pair through the
// Curiouzz Promise's own rails, on demand.
export const sendHonestQuestion = (pairId) =>
  axiosInstance.post("/admin/promise/prompt-pair", { pairId });

export const closePairKindly = (pairId) =>
  axiosInstance.post("/admin/promise/close-pair", { pairId });

// The Introductions board's pair timeline (2026-10-20): oldest first,
// future steps last, server-written plain words with first names. An older
// server answers 404 and the panel says "Timeline not available yet".
export const fetchIntroductionTimeline = (id) =>
  axiosInstance.get(`/admin/interactions/${id}/timeline`);
